module.exports = __webpack_public_path__ + "images/anchored-scales.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/images/anchored-scales.jpg
// module id = 617
// module chunks = 0